module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.nalaganje) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Ranking")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showInfoModal($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "info-box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }), _vm._v(" "), (!_vm.toggleLeaderboard) ? _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v(_vm._s(_vm.$t("pages.exams.ratingResults.completeMoreQuizes")))]) : _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v(_vm._s(_vm.$t("pages.exams.ratingResults.joinedLeaderboard")))]), _vm._v(" "), (!_vm.toggleLeaderboard) ? _c('div', {
    staticClass: "progress-leaderboard"
  }, [_c('div', {
    staticClass: "progress-bar-eighty"
  }), _vm._v(" "), _c('div', {
    staticClass: "progress-bar-leaderboard",
    style: ('width: ' + (1 - _vm.ratingDeviation / 350) * 100 + '%; background: #0073b7')
  })]) : _vm._e(), _vm._v(" "), (!_vm.toggleLeaderboard) ? _c('span', {
    staticClass: "progress-description"
  }, [_vm._v(_vm._s(_vm.$t("pages.exams.ratingResults.yourRatingIsInaccurate")) + " "), _c('b', [_vm._v("75%")])]) : _c('span', {
    staticClass: "progress-description"
  }, [_vm._v(_vm._s(_vm.$t("pages.exams.ratingResults.improveRating")))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "small-box bg-blue",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.showRatingQuizSelection($event)
      }
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('pages.ratingHistory.ratingQuiz')))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('pages.exams.ratingResults.numberOfSolvedExercises')) + "   " + _vm._s(_vm.solvedExercises) + "/" + _vm._s(_vm.allExercises))])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('a', {
    staticClass: "small-box-footer",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.ratingHistory.startQuiz')) + " "), _c('i', {
    staticClass: "fa fa-arrow-circle-right"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.$t("pages.exams.ratingResults.leaderboard")))]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), (_vm.leaderboard.length > 0) ? _c('div', {
    attrs: {
      "id": "leaderboard"
    }
  }, [_c('div', {
    staticClass: "ribbon"
  }), _vm._v(" "), _c('table', _vm._l((_vm.leaderboard.slice(0, 6)), function(user, index) {
    return _c('tr', {
      key: user.username
    }, [(user.place) ? _c('td', {
      staticClass: "number"
    }, [_vm._v(_vm._s(user.place + 1))]) : _c('td', {
      staticClass: "number"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), (user.place) ? _c('td', {
      staticClass: "name",
      staticStyle: {
        "font-weight": "bold",
        "color": "#00a65a"
      }
    }, [_vm._v(_vm._s(user.username))]) : _c('td', {
      staticClass: "name"
    }, [_vm._v(_vm._s(user.username))]), _vm._v(" "), (user.place) ? _c('td', {
      staticClass: "points"
    }, [_vm._v(_vm._s(user.ratingGlicko))]) : _c('td', {
      staticClass: "points"
    }, [_vm._v("\n                  " + _vm._s(user.ratingGlicko) + "\n                  "), (index == 0) ? _c('img', {
      staticClass: "gold-medal",
      attrs: {
        "src": "https://github.com/malunaridev/Challenges-iCodeThis/blob/master/4-leaderboard/assets/gold-medal.png?raw=true",
        "alt": "gold medal"
      }
    }) : _vm._e()])])
  }), 0)]) : _c('div', [_c('div', {
    staticStyle: {
      "padding": "20px",
      "text-align": "center"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('pages.exams.ratingResults.leaderboardEmpty')))])])])])]), _vm._v(" "), (!_vm.dataById) ? _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.ratingHistory.ratingHistory')))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "315px",
      "overflow-y": "auto"
    },
    attrs: {
      "id": "leaderboard"
    }
  }, [_c('table', [_c('tbody', [_c('tr', {
    staticClass: "history-cell"
  }, [_c('th', [_vm._v(_vm._s(_vm.$t('pages.ratingHistory.date')))]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.ratingHistory.numberOfPoints')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('pages.ratingHistory.rating')))])]), _vm._v(" "), _vm._l((_vm.ratingHistory.slice().reverse()), function(izpit, i) {
    return _c('tr', {
      staticClass: "history-cell",
      on: {
        "click": function($event) {
          return _vm.showResultsForOneExam(izpit.examAttemptId)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(new Date(izpit.date).toLocaleString('default', {
      day: 'numeric',
      month: 'short'
    })))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "progress progress-xs",
      staticStyle: {
        "width": "7rem",
        "margin": "auto 0"
      }
    }, [(izpit.points / izpit.maxPoints >= 0.75) ? _c('div', {
      staticClass: "progress-bar progress-bar-green",
      style: ({
        width: (100 * izpit.points / izpit.maxPoints) + '%'
      })
    }) : (izpit.points / izpit.maxPoints >= 0.25) ? _c('div', {
      staticClass: "progress-bar progress-bar-yellow",
      style: ({
        width: (100 * izpit.points / izpit.maxPoints) + '%'
      })
    }) : _c('div', {
      staticClass: "progress-bar progress-bar-red",
      style: ({
        width: (100 * izpit.points / izpit.maxPoints) + '%'
      })
    })])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "badge bg-blue"
    }, [_vm._v(_vm._s(izpit.points.toFixed(1) + '/' + izpit.maxPoints))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center",
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(izpit.newRating))])])
  })], 2)])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v(_vm._s(_vm.$t('pages.ratingHistory.currentRating')))]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number",
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v(_vm._s(_vm.rating))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [(_vm.ratingDeviation <= 70) ? _c('span', {
    staticClass: "info-box-icon bg-gray-light"
  }, [_c('i', {
    staticClass: "fa fa-bullseye",
    staticStyle: {
      "color": "#0073b7"
    }
  })]) : (_vm.ratingDeviation <= 180) ? _c('span', {
    staticClass: "info-box-icon bg-gray-light"
  }, [_c('i', {
    staticClass: "fa fa-bullseye",
    staticStyle: {
      "color": "#f39c12"
    }
  })]) : _c('span', {
    staticClass: "info-box-icon bg-gray-light"
  }, [_c('i', {
    staticClass: "fa fa-bullseye",
    staticStyle: {
      "color": "#dd4b39"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.ratingResults.ratingAccuracy')))]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number",
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v(_vm._s(Math.round((1 - _vm.ratingDeviation / 350) * 100)) + "%")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [(_vm.solvedExercises / _vm.allExercises < 1) ? _c('span', {
    staticClass: "info-box-icon bg-gray-light"
  }, [_c('i', {
    staticClass: "fa fa-list",
    staticStyle: {
      "color": "#0073b7"
    }
  })]) : _c('span', {
    staticClass: "info-box-icon bg-gray-light"
  }, [_c('i', {
    staticClass: "fa fa-list",
    staticStyle: {
      "color": "#00a65a"
    }
  }, [_vm._v(">")])]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.ratingResults.numberOfSolvedExercises')))]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number",
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v(_vm._s(_vm.solvedExercises) + "/" + _vm._s(_vm.allExercises))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.ratingHistory.graph')))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('line-chart', {
    attrs: {
      "height": 125,
      "options": {
        scales: {
          yAxes: [{
            ticks: {
              max: _vm.max,
              min: _vm.min
            }
          }]
        }
      },
      "chartData": _vm.grafRatinga
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.adminpanel.ratingStatistics.group')))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "margin"
  }, [_c('div', {}, [_c('h5', [_vm._v(_vm._s(_vm.$t('pages.adminpanel.ratingStatistics.userRatings')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('Bar', {
    staticStyle: {
      "height": "20em"
    },
    attrs: {
      "height": 125,
      "chartData": {
        labels: _vm.ratingHistogramX,
        datasets: [{
          label: _vm.$t('pages.adminpanel.ratingStatistics.numberOfStudents'),
          backgroundColor: _vm.ratingHistogramBarve,
          data: _vm.ratingHistogramY
        }]
      },
      "options": {
        maintainAspectRatio: false,
        responsive: true,
        scales: {
          xAxes: [{
            stacked: true,
            barPercentage: '1',
            categoryPercentage: '0.9'
          }],
          yAxes: [{
            stacked: true
          }]
        }
      }
    }
  })], 1)])])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal modal-default fade",
    attrs: {
      "id": 'selectSubgroupsModal'
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(5), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.ratingHistory.ratingQuiz')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('pages.exams.ratingResults.ratingQuizInfo')))]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "margin": "20px 0 10px 0"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.subgroups.selectSubgroups')))]), _vm._v(" "), (_vm.loadingSubgroups) ? _c('span', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('pulse-loader', {
    attrs: {
      "color": _vm.spinnerColor,
      "size": _vm.spinnerSize
    }
  })], 1) : _vm._e(), _vm._v(" "), [_c('div', {
    staticClass: "form-group"
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, _vm._l((_vm.filteredSubgroups), function(subgroup) {
    return _c('div', {
      key: subgroup.id
    }, [_c('div', {
      style: ('margin-left: ' + (2 * subgroup.nivo) + 'em')
    }, [(subgroup.list) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.izbranePodskupine),
        expression: "izbranePodskupine"
      }],
      attrs: {
        "type": "checkbox",
        "id": subgroup.id
      },
      domProps: {
        "value": subgroup.id,
        "checked": Array.isArray(_vm.izbranePodskupine) ? _vm._i(_vm.izbranePodskupine, subgroup.id) > -1 : (_vm.izbranePodskupine)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.izbranePodskupine,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = subgroup.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.izbranePodskupine = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.izbranePodskupine = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.izbranePodskupine = $$c
          }
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('label', {
      attrs: {
        "for": subgroup.id
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.toggleSubgroup(subgroup)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(!subgroup.list ? _vm.expandedSymbol(subgroup) : '') + " " + _vm._s(_vm._f("pickTranslation")(subgroup.name)) + "\n                    ")]), _vm._v(" "), (!subgroup.list) ? _c('span', {
      staticClass: "text-light-blue pointer",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.selectAllSbgroupsInTree(subgroup.id, true)
        }
      }
    }, [_vm._v("\n                      (" + _vm._s(_vm.$t('pages.subgroups.addAll')) + ")\n                    ")]) : _vm._e(), _vm._v(" "), (!subgroup.list) ? _c('span', {
      staticClass: "text-light-blue pointer",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.selectAllSbgroupsInTree(subgroup.id, false)
        }
      }
    }, [_vm._v("\n                      (" + _vm._s(_vm.$t('pages.subgroups.removeAll')) + ")\n                    ")]) : _vm._e()])])
  }), 0)], 1)], _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('pages.subgroups.selectDuration')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.izbranoTrajanje),
      expression: "izbranoTrajanje"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.izbranoTrajanje = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("20 min")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "30"
    }
  }, [_vm._v("30 min")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "45"
    }
  }, [_vm._v("45 min")])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.startRatingQuiz($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.subgroups.createQuiz')))])])])])]), _vm._v(" "), (_vm.showInfoModalBoolean) ? _c('div', {
    staticClass: "modal modal-success fade",
    attrs: {
      "id": _vm.modalInfoKey
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(6), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.ratingResults.infoTitle')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('pages.exams.ratingResults.info')) + " ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('pages.exams.ratingResults.infoDeviation')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-outline pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.reports.close')))])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-gray-light"
  }, [_c('i', {
    staticClass: "fa fa-trophy",
    staticStyle: {
      "color": "#0073b7"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-trophy"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-gray-light"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-stats",
    staticStyle: {
      "color": "#0073b7"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8eba978a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8eba978a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/groups/UserRating.vue
// module id = 1426
// module chunks = 1